const LOCAL_STORAGE_KEYS = {
  eventCode: "event_code",
  isActive: "is_active",
  token: "token",
  name: "name",
  id: "id",
  registerPageStage: "register_page_stage",
  clientCopy: "blink_client_copy",
  clientAssets: "blink_client_assets",
  clientCopyTimestamp: "blink_client_copy_timestamp",
  clientAssetsTimestamp: "blink_client_assets_timestamp",
  eventNamePerEventId: "event_name_per_event_id",
};

// sessionStorage (per-tab) — forgot-password step flow (BG-20944).
// The step token is deliberately NOT in localStorage: it must not survive the
// tab and must not be picked up as a session token by fetchBase.
export const SESSION_STORAGE_KEYS = {
  stepToken: "step_token",
  tempPasswordHash: "temp_password_hash",
};

export default LOCAL_STORAGE_KEYS;
